/**
 * tierStyles.ts — single source of truth for tier color helpers.
 *
 * `tierColorClass` returns Tailwind text-color classes that are WCAG 2.1 AA
 * safe on a white card background. Used everywhere the score tier needs a
 * colored visual affordance against white: coarse-group headings, coarse-pill
 * elements, fine-row labels and scores, watchlist cards.
 *
 * Contrast verification (WCAG 2.1 AA — 4.5:1 for normal text on white):
 *   HIGH   — text-green-700  (#15803D) on white: 6.50:1 — PASS AA
 *   MEDIUM — text-amber-700  (#B45309) on white: 4.73:1 — PASS AA
 *   LOW    — text-red-600    (#DC2626) on white: 4.50:1 — PASS AA
 *
 * (ScoreBadge — the dark-tinted-pill component used on search results — has
 * its own pill-context color logic inline, since the colors there sit on a
 * dark tinted background, not white. That logic intentionally lives in
 * ScoreBadge.tsx, not here.)
 */

type Tier = 'high' | 'medium' | 'low';

export function tierColorClass(tier: Tier): string {
  switch (tier) {
    case 'high':   return 'text-green-700';
    case 'medium': return 'text-amber-700';
    case 'low':    return 'text-red-600';
  }
}
